/* eslint-disable */
import React, { useEffect, useState } from "react";
import * as API from '../../framework/API/api'
import { Checkbox } from "@progress/kendo-react-inputs";
import { Form, Field, FormElement } from "@progress/kendo-react-form";
import { BA_ACTION, ENTITYNAME } from "../../framework/constant/constant";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import CollectionSelection from "../../framework/forms/CollectionSelection";
import { OttPosterCollectionSelectionColumns } from "../../framework/utility/customColumns";
import { ImageCell } from "../../framework/forms/helpercomponents/CustomGridCells/ImageCell";
import { toast } from 'react-toastify';
import { useTranslation } from "../../locale/useTranslation";
import AddRoundButton from "../../framework/forms/helpercomponents/buttons/AddRoundButton";
import SaveRoundButton from "../../framework/forms/helpercomponents/buttons/SaveRoundButton";
import CancelRoundButton from "../../framework/forms/helpercomponents/buttons/CancelRoundButton";
import EditRoundButton from "../../framework/forms/helpercomponents/buttons/EditRoundButton";
import DeleteRoundButton from "../../framework/forms/helpercomponents/buttons/DeleteRoundButton";
import BrowseRoundButton from "../../framework/forms/helpercomponents/buttons/BrowseRoundButton";
import { ConfirmDeleteAlert } from '../../ConfirmAlert'
import { useRef } from "react";
import PreviewRoundButton from "../../framework/forms/helpercomponents/buttons/PreviewRoundButton";
import ImagePreviewPage from "../../components/ImagePreviewPage";
import BossDialog from "../../components/BossDialog";
import BossAssistantIcon from "./component/BossAssistantIcon";
import { utility } from "../../framework/utility/utilityProvider";

function OttAssetPosterEditForm(props) {

  const [ottPosterType, setOttPosterType] = useState([]);

  let initialValue = {
    Description: "",
    OttPosterType: "",
    Url: "",
  }
  const [dataItem, setDataItem] = useState(initialValue);
  const [i, setI] = useState(0);
  const [editMode, setEditMode] = useState(false);
  const [toggle, setToggle] = useState(false);
  const [openImageBank, setOpenImageBank] = useState(false);
  const [selectedImageUrl, setSelectedImageUrl] = useState('https://i.postimg.cc/j5PsF5jZ/defaultmovie.png');
  const lang = useTranslation();
  const selectedIndexRef = useRef(0);
  const setSelectedIndexRef = (data) => {
    selectedIndexRef.current = data;
  }
  const [previewPageOpen, setPreviewPageOpen] = useState(false);
  const [imagePreview, setImagePreview] = useState(false);

  const [gridData, setGridData] = useState([]);


  useEffect(() => {
    loadcombo();
  }, []);

  useEffect(() => {
    let posterData = [];
    // let isoCode = props.selectedLanguage ? props.selectedLanguage.ISOCode : "en_US1"; //FOR NULL HANDLING
    if (Array.isArray(props?.data) && props.data.length > 0 && props.data[0]?.langISO) {
      const langData = props.data.find(x => x?.langISO === props?.selectedLanguage?.ISOCode);
      if (Array.isArray(langData?.value)) {
        posterData = [...langData.value];
      }
    } else if (Array.isArray(props?.data)) { posterData = [...props.data]; }
    setGridData(posterData);

  }, [props.selectedLanguage])

  //to get data from collection on edit
  const onEdit = (dataItem) => {
    setDataItem(dataItem);
  }

  const onChange = (e) => {
    setDataItem({ ...dataItem, [e.target.name]: e.target.value });
  }

  const loadcombo = async () => {
    var ottPosterType = await API.getDataLookup(ENTITYNAME.OttPosterType, { sort: { Description: 1 } });
    setOttPosterType(ottPosterType.data);
  }

  const isValid = (item = dataItem) => {
    if (item.OttPosterType == undefined || Object.keys(item.OttPosterType).length == 0) {
      toast.error(
        <div>
          <strong>INVALID</strong>
          <div style={{ fontSize: '13px' }}>{lang.please_select_poster_type_first_media_episode_poster_error_message}</div>
        </div>,
        { position: toast.POSITION.TOP_RIGHT }
      );
      return false;
    }
    if (item.Url == undefined || Object.keys(item.Url).length == 0) {
      toast.error(
        <div>
          <strong>INVALID</strong>
          <div style={{ fontSize: '13px' }}>{lang.please_select_url_first_media_episode_poster_error_message}</div>
        </div>,
        { position: toast.POSITION.TOP_RIGHT }
      );
      return false;
    }
    return true;

  }

  const addPoster = (item = dataItem) => {
    if (isValid(item)) {
      const dataNew = {
        Description: item.Description,
        OttPosterType: typeof item.OttPosterType === "string" ? { SID: JSON.parse(item.OttPosterType).SID, Description: JSON.parse(item.OttPosterType).Description } : { SID: item.OttPosterType.SID, Description: item.OttPosterType.Description },
        Url: item.Url
      }
      let newData = [...props.data];
      let langDataIndex = props.data.findIndex(x => x?.langISO === props?.selectedLanguage?.ISOCode);
      if (langDataIndex === -1) {
        newData = [...props.data, { langISO: props?.selectedLanguage?.ISOCode, value: [dataNew] },];
      } else {
        let langData = { ...props.data[langDataIndex] };
        langData.value = [...(Array.isArray(langData.value) ? langData.value : []), dataNew];
        newData[langDataIndex] = langData;
      }
      setGridData(newData.find((x) => x?.langISO == props?.selectedLanguage?.ISOCode).value);
      props.setOttPostersData([...newData])

      setI(i + 1);
      setDataItem(initialValue);
      clearData();
    }
  }

  const MyCommandCell = (props) => (

    <div className="mt-4" style={{ display: "flex" }}>
      <EditRoundButton onClick={() => editFormGrid(props)} />
      <DeleteRoundButton onClick={() => ConfirmDeleteAlert(() => removePosters(props.dataIndex), () => { })} />
      <PreviewRoundButton onClick={(e) => { setPreviewPageOpen(true); openImagePreview(props) }} />
    </div>
  )

  const editFormGrid = (data) => {
    console.log(data);

    let dataItem = data.dataItem;
    setSelectedIndexRef(data.dataIndex);
    setDataItem(dataItem);
    setToggle(true);
    setEditMode(true);
  }

  const openImagePreview = (data) => {
    let dataItem = data.dataItem;
    setImagePreview(dataItem);

  }

  const removePosters = (index) => {

    let langDataIndex = props.data.findIndex((x) => x?.langISO === props?.selectedLanguage?.ISOCode);
    if (langDataIndex === -1) return;

    let langData = [...props.data];
    let values = [...langData[langDataIndex].value];
    values.splice(index, 1);

    langData[langDataIndex] = { ...langData[langDataIndex], value: values };

    props.setOttPostersData(langData);
    setGridData(values);

    setI((prev) => prev - 1);

    toast.success(
      `${lang.delete_successfully_grid_data_success_toast_message}`,
      { position: toast.POSITION.TOP_RIGHT }
    );
  };

  const editPosters = () => {
    if (isValid()) {
      let newData = [...props.data];
      let langDataIndex = props.data.findIndex(
        (x) => x?.langISO === props?.selectedLanguage?.ISOCode
      );

      if (langDataIndex === -1) {
        newData.push({ langISO: props?.selectedLanguage?.ISOCode, value: [dataItem] });
      } else {
        let langData = { ...newData[langDataIndex] };
        let values = [...langData.value];
        values[selectedIndexRef.current] = dataItem;

        langData.value = values;
        newData[langDataIndex] = langData;
      }
      setGridData(newData.find((x) => x?.langISO === props?.selectedLanguage?.ISOCode).value);
      props.setOttPostersData([...newData]);
      setEditMode(false);
      clearData();
    }
  };

  const clearData = () => {
    setDataItem(initialValue);
    setEditMode(false);
    setToggle(false);
  }

  const setSelectedImage = (dataList) => {
    if (dataList.length > 0) {
      let selectedImageURL = dataList[0].ImageUrl;
      setSelectedImageUrl(selectedImageURL);
      setDataItem({ ...dataItem, ["Url"]: selectedImageURL });
    } else {
      toast.error(`${lang.no_select_image_error_message}`, {
        position: toast.POSITION.TOP_RIGHT
      });
    }

  }

  const onClosedPreview = async () => {
    setPreviewPageOpen(false);
  }

  const onBossAIImageUrlLoad = async (item) => {

    let aiDataRes = await utility.loadDataViaBOSS_AI(BA_ACTION.PortraitImageUrl, item, props.mediaData);
    console.log(aiDataRes);
    return aiDataRes;

  }

  const setPosterData = (newData) => {

    console.log("HERE IN MEDIA EPISODE POSTER")
    console.log(newData);

    if (newData.success) {

      let assetTitle = utility.getItemDisplayValueByLang(props.mediaData.Title, props.selectedLanguage);

      // imageUrl
      let newPosterItem = {
        Description: `${assetTitle} portrait image`,
        OttPosterType: ottPosterType.find((x) => x.Description == "Portrait") ?? ottPosterType[0],
        Url: newData.imageUrl
      }

      addPoster(newPosterItem);

    } else {
      toast.error(`${newData.message}`, {
        position: toast.POSITION.TOP_RIGHT
      });
    }

  }

  return (<div style={{ boxShadow: "0px 0px 10px 1px lightgrey", backgroundColor: "#EEEEEE", borderRadius: "10px", padding: "10px 20px 20px 20px" }}>
    <div className="row">
      <div className={"col-12"}>

        <div style={{ display: "flex", width: "100%", justifyContent: "space-between", alignItems: "center" }}>

          <div><AddRoundButton onClick={() => setToggle(true)} /></div>
          <BossAssistantIcon
            style={{}}
            mediaEpisodeEntity={{
              ...props.mediaData,
              Title: utility.getItemDisplayValueByLang(props.mediaData.Title, props.selectedLanguage),
              Description: utility.getItemDisplayValueByLang(props.mediaData.Description, props.selectedLanguage),
            }}
            iconSize={"35px"}
            onDataLoad={onBossAIImageUrlLoad}
            popupTtle={"Get Portrait Image with Boss AI"}
            tooltip={"Get Portrait Image with Boss AI"}
            description={"BOSS AI fetching Portrait Image"}
            setMetaData={setPosterData}
          />

        </div>
        <Grid data={gridData} style={{ height: "20vh" }} className="mt-2">
          <GridColumn cell={MyCommandCell} width={"100px"} locked={true} />
          <GridColumn field="Description" title={lang.description_column} editable={false} />
          <GridColumn field="OttPosterType.Description" title={lang.poster_type_column} editable={false} />
          <GridColumn field="Url" title={lang.image_column} cell={ImageCell} editable={false} />
        </Grid>
      </div>
      {toggle &&
        <BossDialog
          title={dataItem?.OttPosterType?.Description ? dataItem?.OttPosterType?.Description : lang.create_poster_dialog_header}
          onClose={() => setToggle(false)}
          width={700}
          height={300}
        >
          <div className="row">
            <div className="col-12">
              <Form
                render={(formRenderProps) => (
                  <FormElement>
                    <div className="row mt-2">
                      <div className="marlr">
                        {!editMode && <AddRoundButton onClick={() => addPoster()} />}
                        {editMode && <SaveRoundButton onClick={() => { editPosters() }} />}
                        <CancelRoundButton onClick={clearData} />
                      </div>
                    </div>
                    <div className="mt-2" style={{ border: "groove 1px" }}>
                      <div className="row" style={{ margin: "5px" }}>
                        <div className="col-12 mt-2">
                          <div className="row">
                            <div className="col-6">
                              <div className="form-group">
                                <label htmlFor="TabView">{lang.poster_type_label} *</label>
                                <DropDownList
                                  style={{
                                    backgroundColor: "white",
                                  }}
                                  data={ottPosterType}
                                  name="OttPosterType"
                                  textField="Description"
                                  dataItemKey="_id"
                                  value={dataItem.OttPosterType}
                                  onChange={onChange}
                                  validator={(value) => value ? "" : "Please select the value"}
                                />
                              </div>
                            </div>
                            <div className="col-6">
                              <div className="form-group">
                                <label htmlFor="">{lang.description_label}</label>
                                <input type="text" className="form-control form-control-sm" name="Description" value={dataItem.Description} onChange={(e) => onChange(e)} />
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-5">
                              <div className="form-group">
                                <label htmlFor="">{lang.url_label} *</label>
                                <input type="text" className="form-control form-control-sm" name="Url" value={dataItem.Url} onChange={(e) => onChange(e)} />
                              </div>
                            </div>
                            <div style={{ marginTop: "20px" }}>
                              <BrowseRoundButton onClick={() => setOpenImageBank(true)} />
                            </div>
                            {/* <div className="col-6 ml-3" style={{ marginTop: "20px" }}>
                              <Field
                                name={"Archive"}
                                component={Checkbox}
                                label={lang.archive}
                                onChange={(e) => onChange(e)}
                                checked={dataItem.Archive}
                              />
                            </div> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </FormElement>

                )} />
            </div>
          </div>
        </BossDialog>}
    </div>
    {openImageBank && <CollectionSelection entityname={ENTITYNAME.OttPosters} customColumns={OttPosterCollectionSelectionColumns} title={lang.select_url_tooltip} closeForm={() => setOpenImageBank(!openImageBank)} setDataList={setSelectedImage} mode={"single"} width={"55vw"} />}
    {previewPageOpen &&
      <ImagePreviewPage image={imagePreview.Url} onClose={onClosedPreview}></ImagePreviewPage>
    }
  </div>
  )
}

export default OttAssetPosterEditForm